import React, { useEffect, useState, useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Box, Grid, Tab, Tabs } from "@mui/material";
import { useBuyManagers } from '../../customHooks/useBuyManagers';

import CreateSwarmsRefactor from '../AdminSwarm/CreateSwarms/CreateSwarmsRefactor';
import RequestHistory from '../AdminSwarm/RequestHistory/RequestHistory';
import ActiveSwarms from "./features/activeSwarms/index";
import PendingBuyRequests from "../AdminSwarm/PendingBuyRequests";
import RequestActivity from "../AdminSwarm/RequestActivity/RequestActivity";
import SwarmsHistory from "./features/swarmsHistory/SwarmsHistory";

const OldActiveSwarms = ({ showError, setShowError }) => {
  useBuyManagers();
  function getDefaultsValues(searchParams) {
    return {
      pageNumber: Number(searchParams.get("pageNumber")) || 1,
    }
  }
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const history = useHistory();
  const { pageNumber} = getDefaultsValues(searchParams);

  useEffect(() => {
    searchParams.set("tab_index", 0); //A: this is the index of the tab in the admin tools
    // searchParams.set("pageNumber", pageNumber);
    history.push(`/dashboard/adminswarm?${searchParams.toString()}`);
  }, [pageNumber]);

return (
  <div style={{ width: "100%" }} >
    <PendingBuyRequests
      showError={showError}
      setShowError={setShowError}
    />
    <RequestActivity />
  </div>)
}

export default function AdminSwarmHomePage() {
  const renderCount = useRef(0);
  console.log('[AdminSwarmHomePage] . render count:', ++renderCount.current);

  const [showError, setShowError] = useState({ open: false, text: '' })
  
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  let tabIndexFromQuery = Number(query.get("tab_index") || 0);
  const [selectedTab, setTabIndex] = React.useState(tabIndexFromQuery);

  const history = useHistory();

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
    query.set("tab_index", newValue);
    history.push({ search: query.toString() });
  };

  return (
    <Grid container spacing={0} alignItems="center" justifyContent="center" style={{ marginTop: "5.5em", width: "100%", padding: '0 1em' }}>
      <Box sx={{ borderBottom: 1, borderColor: "var(--light-yellow)", width: "100%", margin: '0 0 0.5em 0' }}>
        <Tabs value={selectedTab} onChange={handleChange} textColor="primary" indicatorColor="primary">
          <Tab label="Active Swarms" id={`active-swarms-tab`} />
          <Tab label="Create Swarms" id={`create-swarms-tab`} />
          <Tab label="Request History" id={`request-history-tab`} />
          <Tab label="Swarms History" id={`swarms-history-tab`} />
          <Tab label="Old Active Swarms" id={`old-active-swarms-tab`} />
        </Tabs>
      </Box>
      {selectedTab === 0 && <ActiveSwarms showError={showError} setShowError={setShowError} />}
      {selectedTab === 1 && <CreateSwarmsRefactor />}
      {selectedTab === 2 && <RequestHistory setShowError={setShowError} />}
      {selectedTab === 3 && <SwarmsHistory setShowError={setShowError} />}
      {selectedTab === 4 && <OldActiveSwarms showError={showError} setShowError={setShowError} />}
    </Grid>
  )
}
